import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import Vuelidate from "vuelidate";

// Import Bootstrap an BootstrapVue CSS files (order is important)
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

// Use a global stylesheet.
//import "@/styles/global.scss";

//defined as global component
Vue.component(
  "VueFontawesome",
  require("vue-fontawesome-icon/VueFontawesome.vue").default
);

Vue.config.productionTip = false;

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

// Validation styles.
Vue.use(Vuelidate);

var VueCookie = require("vue-cookie");
// Tell Vue to use the plugin
Vue.use(VueCookie);

// Pass appdata a Vue.prototype definition.
Vue.prototype.$appdata = window.appdata;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
